<template>
  <v-container fluid>
      <v-img :src='`${publicPath}img/camp-banner.png`'/>
    <v-card>

      <v-toolbar>
        <v-toolbar-title>Sign Up For Virtual Camp 2020</v-toolbar-title>
        <v-spacer />
        <span class="d-none d-lg-block">Filter Camps</span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="showFilter = !showFilter" v-bind="attrs"
            v-on="on">
            <v-icon>{{showFilter ? 'mdi-close':'mdi-filter-variant'}}</v-icon>
          </v-btn>
        </template>
        <span>Filter Courses</span>
      </v-tooltip>
        
      </v-toolbar>
      <v-expand-transition>
      <v-card-text v-if="showFilter" transition="fade-transition">
        <v-row>
          <v-col cols="12">
                      Filter available camps by grade and dates
          </v-col>
          <v-col cols="12">
            <v-select
              dense
              v-model="grade"
              :items="grades"
              item-text="name"
              item-value="value"
              label="Grade"
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-select
            v-model="selectedWeeks"
              dense
              multiple
              chips
              :items="weeks"
              item-text="name"
              item-value="value"
              label="Weeks"
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-btn @click="filterCourses">Filter</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      </v-expand-transition>
    </v-card>

    <v-subheader v-if="courses && courses.length > 0" class="mt-5">Found {{courses.length}} results</v-subheader>
    <div class="my-5 text-center">
      <v-pagination v-if="totalPages > 1" v-model="page" :length="totalPages" circle></v-pagination>
    </div>
    <v-card class="my-5" v-for=" course in courses " :key="course.id">
      <v-card-title>
        <router-link :to="`/course/${course.id}`"> {{course.name}} </router-link>
        <v-spacer />
        <v-btn icon title="In Cart">
          <v-icon v-if="inCart(course)">mdi-cart-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="mb-5" v-if="course.scheduleEnd && course.scheduleStart">
          Schedule: {{formatDate(course.scheduleStart)}} - {{formatDate(course.scheduleEnd)}}
        </div>
        <div class="mb-5" >
          Price: {{course.pricePerWeek | currency}} per week
        </div>

        <div class="mb-5" >
        Course Description:<br/>
        {{course.description}}
         </div>
      </v-card-text>
    </v-card>
    <div class="text-center">
      <v-pagination v-if="totalPages > 1" v-model="page" :length="totalPages" circle></v-pagination>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from 'moment';
// import Qs from "qs";

export default {
  data: () => ({
    publicPath: process.env.BASE_URL,
    showFilter: false,
    page: 1,
    totalPages: 0,
    searchTerms: "",
    courses: [],
    weekTopics: [
      {
        week: "1",
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        sessions: [{ name: "", description: "" }]
      }
    ],
    selectedWeeks: [],
    weeks: [
    ],
    grade: null,
    grades: [
      { value: "0", name: "Kindergarten" },
      { value: "1", name: "1st Grade" },
      { value: "2", name: "2nd Grade" },
      { value: "3", name: "3rd Grade" },
      { value: "4", name: "4th Grade" },
      { value: "5", name: "5th Grade" },
      { value: "6", name: "6th Grade" },
      { value: "7", name: "7th Grade" },
      { value: "8", name: "8th Grade" }
    ]
  }),
  computed: {
    ...mapGetters(["cartItemList"])
  },
  watch: {
    page(newPage) {
      this.loadData(newPage, this.selectedWeeks);
    },
    grade(newGrade){
      console.log(`loading weeks for grade: ${newGrade}`)
      this.loadWeeks();
    }
  },
  methods: {
    ...mapActions(["addMessage", "addErrorMessage", "updateCart"]),
    inCart(course) {
      console.log(this.cartItemList);
      return (
        this.cartItemList
          .map(item => {
            return item.id;
          })
          .indexOf(course.id) > -1
      );
    },
    formatDate(date){
      return moment(date).format('MM/DD/YYYY');
    },
    loadData(page, weeks) {
      
      // const weeksCsv = (weeks && weeks.length > 0) ? weeks.join(","):'';
      const data = { pageSize: 10, pageIndex: page, weeks, grade: this.grade, subject: 'Camp',
          sortInfos: [{ sortCol: 'grade', sortDir: 'asc'}]};
      this.$axios
        .post("public/classroom/open-enrollment-courses", data)
        .then(resp => {
          console.log(resp.data);
          this.courses = resp.data.content || [];
          this.totalPages = resp.data.totalPages;
        })
        .catch(error => {
          console.log(error);
          this.addErrorMessage("Error loading courses from server");
        });
    },
    loadWeeks(){
      const params = {subject: 'Camp', grade: this.grade, status: 'Open Enrollment'};
      this.$axios.get('/public/course/available/weeks', { params })
      .then(resp => {
        const weeks = resp.data.data;
        this.weeks = weeks.map( w => { return {name: `${moment(w.start).format('dddd, MMM DD YYYY')} ~ ${moment(w.end).format('dddd, MMM DD YYYY')} (${w.courseCount} camps)`, value: w.yearWeek} });
        this.weeks = this.weeks.sort( (a, b) =>  a.value > b.value ? 1 : -1 );
      })
    },
    filterCourses(){
      this.loadData(this.page, this.selectedWeeks);
      this.showFilter = false;
    },
    // goToCourse(course){
    //   console.log(course)
    //   this.$router.push({path: '/course/'+course.id, params: {id: course.id}});
    // }
  },
  created() {
    this.loadWeeks();
    this.loadData(this.page);
  }
};
</script>

<style>
</style>